import { useEffect } from 'react';

/**
 * Injects one deduped `<link rel="stylesheet">` per href into `document.head`
 * — parity with what the generated embed snippet does for a customer's page,
 * so the operator's preview shows exactly what they will ship. See
 * `fontLinkLines` in `utils.ts` for the snippet-side counterpart.
 */
export const useFontLinks = (hrefs: string[]): void => {
    useEffect(() => {
        hrefs.forEach((href) => {
            if (
                document.head.querySelector(
                    `link[data-starjack-font="${href}"]`
                )
            ) {
                return;
            }

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.dataset.starjackFont = href;
            document.head.appendChild(link);
        });
    }, [hrefs]);
};
